export const PORTAL = {
  page: 'portal-page',
  emailInput: 'portal-email-input',
  requestButton: 'portal-request-button',
  sentConfirmation: 'portal-sent-confirmation',
  reportsList: 'portal-reports-list',
  reportCard: 'portal-report-card',
  viewReportButton: 'portal-view-report-button',
  errorMessage: 'portal-error-message',
  requestNewLinkButton: 'portal-request-new-link-button',
};
